export default __webpack_public_path__ + "static/media/01b_fold-2.1d5ac0d6.mp4";